import { assign } from 'lodash';
import { map } from 'lodash/fp';
import { ReactNode } from 'react';

export interface OptionProps<Value extends string | number> {
    value?: Value | null;
    name?: string | null;
    label?: ReactNode;
    disabled?: boolean;
    secondaryText?: ReactNode;
    indent?: boolean;
    inactive?: boolean;
}

export function Option<Value extends string | number>({
    value = null,
    name = null,
    label = '',
    disabled = false,
    secondaryText = null,
    indent = false,
    inactive = false,
}: OptionProps<Value> = {}) {
    return assign(Object.create(Option.prototype), { name, value, label, secondaryText, disabled, indent, inactive });
}

/**
 * just a alias for using it as a value type instead of props type with optional fields
 */
export type OptionType<T extends string | number> = Required<OptionProps<T>>;

export const mapOption = map(Option);
